import { stringifyFptiProps } from '@/utils'

export function getPayButtonFpti(eventName: string) {
  return stringifyFptiProps({
    eventName,
    link: 'seller_b_profile_pay',
  })
}
